'use client';
import React from 'react';
import styles from './FusionHeader.module.scss';
import { BenzingaLogo } from '@benzinga/logos-ui';
import { FusionHeaderBurger } from './FusionHeaderBurger';
import { useWindowSize } from '@benzinga/hooks';
import { FusionNavigationLink, FusionNavigationLinks } from './FusionNavigationLinks';

export interface FusionHeaderProps {
  attrs?: {
    data?: {
      pageTitle: string;
      navigationLinks: FusionNavigationLink[];
      burgerMenuLinks: {
        title: string;
        subtitle: string;
        url: string;
      }[];
    };
  };
}

export const FusionHeader = ({ attrs }: FusionHeaderProps) => {
  const { width } = useWindowSize();
  const isLaptop = width >= 1440;
  const isMobile = width < 768;
  const headerHeight = 56;

  return (
    <div
      className={`${styles.fusionHeaderContainer} fusion-header-container`}
      style={{ '--header-height': `${headerHeight}px` } as React.CSSProperties}
    >
      <div className="fusion-header-logo-block-wrapper">
        <a aria-label="Click to go home" className="fusion-header-logo-wrapper" href="/">
          <BenzingaLogo variant="light" />
        </a>
        <div className="fusion-header-separator" />
        <p className="fusion-header-bread-crumb">{attrs?.data?.pageTitle}</p>
      </div>
      {Array.isArray(attrs?.data?.navigationLinks) && attrs?.data?.navigationLinks.length && isLaptop && (
        <FusionNavigationLinks links={attrs?.data.navigationLinks} />
      )}
      <FusionHeaderBurger
        burgerMenuLinks={attrs?.data?.burgerMenuLinks || []}
        headerHeight={headerHeight}
        isMobile={isMobile}
        navigationLinks={attrs?.data?.navigationLinks || []}
      />
    </div>
  );
};
